import { render, staticRenderFns } from "./ALDialog.vue?vue&type=template&id=0d013c78&"
import script from "./ALDialog.vue?vue&type=script&lang=ts&"
export * from "./ALDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ALDialog.vue?vue&type=style&index=0&id=0d013c78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports